import http from "../../core/services/http.service";

function toParams(filters = {}) {
  const params = {};
  Object.keys(filters).forEach((key) => {
    if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '') {
      params[key] = filters[key];
    }
  });
  return params;
}

const ApiUsageService = {
  getReport(filters = {}) {
    return http.get('/api/v1/api-usage/report/', {params: toParams(filters)});
  },
  getFilters() {
    return http.get('/api/v1/api-usage/filters/');
  },
  exportXlsx(filters = {}) {
    return http.get('/api/v1/api-usage/export/', {params: toParams(filters), responseType: 'blob'});
  }
};

export default ApiUsageService;
